import { render, staticRenderFns } from "./DetailRowRetours.vue?vue&type=template&id=036a093e&scoped=true&"
import script from "./DetailRowRetours.vue?vue&type=script&lang=js&"
export * from "./DetailRowRetours.vue?vue&type=script&lang=js&"
import style0 from "./DetailRowRetours.vue?vue&type=style&index=0&id=036a093e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036a093e",
  null
  
)

export default component.exports